module.exports = __webpack_public_path__ + "img/ar_sound.490bddaf.png";